import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useQueryClient} from '@github-ui/react-query'
import {useLocation, useNavigate} from '@github-ui/react-router'
import {useCallback, useLayoutEffect, useRef} from 'react'
import {CachesList} from '../components/caches/CachesList'
import {actionsCachesRoute} from './actions-caches-route'

export function CachesRoute() {
  const query = useRouteQuery(actionsCachesRoute, 'mainQuery')
  const queryClient = useQueryClient()
  const location = useLocation()
  const navigate = useNavigate()
  const activeLocationRef = useRef<typeof location | null>(null)
  useLayoutEffect(() => {
    activeLocationRef.current = location
    return () => {
      activeLocationRef.current = null
    }
  }, [location])
  const onDeleted = useCallback(async () => {
    const payload = query.data
    const previousPage =
      payload && payload.page > 1 && payload.page === payload.totalPages && payload.cacheItems.length === 1
    await queryClient.invalidateQueries({
      queryKey: [...query.queryKey.slice(0, 4), {pathname: location.pathname}],
      refetchType: previousPage ? 'none' : 'active',
    })
    if (previousPage && activeLocationRef.current === location) {
      const params = new URLSearchParams(location.search)
      if (payload.page === 2) params.delete('page')
      else params.set('page', String(payload.page - 1))
      const search = params.toString()
      navigate(`${location.pathname}${search ? `?${search}` : ''}`, {replace: true, preventAutofocus: true})
    }
  }, [query.data, query.queryKey, queryClient, location, navigate])
  if (query.isError && query.data === undefined) throw query.error
  if (query.data?.error) throw new Error(query.data.error)
  return query.data ? <CachesList payload={query.data} onDeleted={onDeleted} /> : null
}
